import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    root: {
        padding: tokens.spacingVerticalL,
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalS,
    },
    headerTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
    card: {
        border: `1px solid ${tokens.colorBrandStroke1}`,
    },
    cardTextGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: 'flex-start',
    },
    archiveOptions: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
        marginTop: tokens.spacingVerticalXS,
        paddingLeft: tokens.spacingHorizontalM,
    },
    noteText: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
    },
    footer: {
        display: 'flex',
        justifyContent: 'center',
    },
});